import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserService } from '../services/user.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TourService } from '../services/tour.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isInAdminPanel = false;
  isUserAdmin = false;
  isAuthenticated = false;
  showDropdown = false;
  enableUserMenu = false;
  userName = ''

  constructor(private _userServices : UserService, private _router : Router, private _cdr : ChangeDetectorRef, public tourService : TourService) {

  }

  ngOnInit(): void {
    this._userServices.getUserDetails().subscribe((value: any) => {
      if (value != undefined && Object.keys(value).length > 0) {
        this.userName = `${value.firstName.substring(0, 1)}${value.lastName.substring(0, 1)}`
        this.isAuthenticated = true;
      } else {
        this.isAuthenticated = false;
      }
    })
    this._userServices.getUserMenu().subscribe((value: any) => {
      if (value === true) {
        this.enableUserMenu = true
      } else {
        this.enableUserMenu = false
      }
    })
    this._userServices.getSchoolId().subscribe(value => {
      if (value === null) this._router.navigate(['/dashboard'])
    })
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  logout() {
    this.showDropdown = !this.showDropdown;
    this._userServices.setUserDetails({})
    this._userServices.setUserMenu(false);
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/'])
  }

  startTour() {
    this._router.navigate(['/dashboard'])
    this.tourService.startTour()
  }

}
